export default __webpack_public_path__ + "static/media/UploadIcon.740ca406.png";